import React, { useCallback, useEffect, useState } from "react";
import "../AddDevice/AddDevice.scss";
import DeviceListIcon from "../../assets/images/icCar.png";
import DeviceActionIcon from "../../assets/images/icCar-action.png";
import Searchimg from "../../assets/images/search-icon.svg";
import Shareicons from "../../assets/images/share-icon.svg";
import { getDeviceIcon } from "../../utils/deviceIcons";
import DeviceAddModal from "./DeviceAddModal";
import { Button } from "react-bootstrap";
import DeleteModal from "../Deletemodal/DeleteModal";
import useApi from "../../hook/useAPI";
import { debounce } from "lodash";
import { DEVICE } from "../../utils/const";
import { toast } from "react-toastify";
import DeviceStatusBadge, { DeviceConnectionText } from "../DeviceStatus/DeviceStatusBadge";

const AddDevice = ({ setData, devices, handleMenu, AddDeviceData }) => {


  const { getData, deleteData } = useApi();
  const [modelshow, setModelshow] = useState(false);
  const [deleteshow, setDeleteShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [deviceData, setDeviceData] = useState([]);
  const [Id, setId] = useState("");
  // const deviceStoredData = JSON.parse(localStorage.getItem("deviceData")) || [];
  const deviceStoredData = [];
  const handleClose = () => {
    setModelshow(false);
    if (AddDeviceData) {
      AddDeviceData();
    }
    setId("");
  };

  const GetCurrentDeviceStatus = useCallback(
    debounce(async (query) => {
      try {
        const safeSearch = (query || "").trim();
        const response = await getData(
          `${DEVICE?.GET_CURRENT_DEVICE_STATUS}?page=${currentPage}&limit=${itemsPerPage}&search=${encodeURIComponent(safeSearch)}`
        );
        if (response.status === 200 && response?.data.length > 0) {
          const deviceData = await response?.data;
          // localStorage.setItem("deviceData", JSON.stringify(deviceData));
          setDeviceData(response?.data);
          setData(response?.data);
        }
      } catch (error) {
        console.error("Error fetching device details:", error);
      }
    }, 500),
    []
  );
  // console.log(deviceData, "deviceeeee")
  useEffect(() => {
    GetCurrentDeviceStatus(searchTerm);
  }, [searchTerm]);

  useEffect(() => {
    if (devices?.length > 0) {
      setDeviceData(devices);
    }
  }, [devices]);
  const GetDevice = () => {
    GetCurrentDeviceStatus(searchTerm);
  };

  const SearchCurrentData = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  };
  const handleClosedelete = () => {
    setDeleteShow(false);
    setId("");
  };
  const DeleteData = async () => {
    try {
      if (Id) {
        const response = await deleteData(`${DEVICE.CREATE_DEVICE}/${Id}`);
        if (response?.status == 200) {
          toast.success(response?.message);
          setDeleteShow(false);
          GetCurrentDeviceStatus(searchTerm);
        }
      }
    } catch (error) {
      console.error("Error delete device", error);
    }
  };

  useEffect(() => {
    if (deviceData.length > 0) {
      let currentDeviceId = localStorage.getItem("current_select_device_id");

      if (currentDeviceId) {
        const deviceData_ = deviceData?.filter((item) => item?._id === currentDeviceId);
        if (deviceData_.length > 0) {
          handleMenu(deviceData_[0]);
        }
        // console.log("deviceData", deviceData,currentDeviceId,deviceData_);
      }

    }
  }, [deviceData]);
  const handleEdit = (editId) => {
    setModelshow(true);
    setId(editId);
  };
  const handleDelete = (deleteId) => {
    setDeleteShow(true);
    setId(deleteId);
  };
  return (
    <>
      <div className="home-device-box">
        <div className="top_bar">
          <div className="card_title">Devices</div>
          <div className="form_field_wrapper">
            <Button onClick={() => setModelshow(true)}>Add New Device</Button>
          </div>
        </div>
        <div className="bottom_bar">
          <div className="search-box-wrap mb-3">
            <img className="search-box-icon" src={Searchimg} alt="Searchimg" />
            <input
              type="text"
              placeholder="Search or type a device name"
              onChange={(e) => SearchCurrentData(e)}
            />
          </div>
          <div className="device-list-box">
            {deviceData.map((item) => (
              <div className="device-list" key={item._id}>
                <div className="device-icon">
                  <img src={getDeviceIcon(item.deviceCategory)} alt="" />
                </div>

                <div
                  className="device-name"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleMenu(item)}
                >
                  <h5 className="ellipsis-text">{item?.name}</h5>
                  <DeviceConnectionText device={item} />
                </div>

                <DeviceStatusBadge device={item} />

                <div className="device-action">
                  <button
                    id="dropdownMoreMenu1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={DeviceActionIcon}
                      className="img-fluid"
                      alt="three-dot-image"
                    />
                  </button>
                  <ul
                    className="profile dropdown-menu"
                    aria-labelledby="dropdownMoreMenu1"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer"
                      }}
                    >
                      <li>
                        <div
                          className="dropdown-item"
                          onClick={() => handleEdit(item?._id)}
                        >
                          <span className="item_text">Edit</span>
                        </div>
                      </li>
                      <li>
                        <div
                          className="dropdown-item"
                          onClick={() => handleDelete(item?._id)}
                        >
                          <span className="item_text">Delete</span>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <DeviceAddModal
        show={modelshow}
        handleClose={handleClose}
        ID={Id}
        AddDevice={GetDevice}
      />
      <DeleteModal
        show={deleteshow}
        handleClose={handleClosedelete}
        handleDeleteData={DeleteData}
      />
    </>
  );
};

export default AddDevice;
